"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = void 0;
const storage = () => {
    const namespace = 'gpasfe';
    const getItems = () => {
        const storage = localStorage.getItem(namespace);
        if (!storage) {
            localStorage.setItem(namespace, JSON.stringify({}));
            return {};
        }
        return JSON.parse(storage);
    };
    const expireItems = (storage) => {
        for (const key in storage) {
            if (Object.prototype.hasOwnProperty.call(storage, key)) {
                const item = storage[key];
                // compare the expiry time of the item with the current time
                if ((item === null || item === void 0 ? void 0 : item.expiry) && Date.now() > (item === null || item === void 0 ? void 0 : item.expiry)) {
                    // If the item is expired, delete the item from storage
                    delete storage[key];
                }
            }
        }
        localStorage.setItem(namespace, JSON.stringify(storage));
        return storage;
    };
    const setStorage = (key, value, ttl = 86400) => {
        const storage = expireItems(getItems());
        storage[key] = {
            value: JSON.stringify(value),
            expiry: Date.now() + (ttl * 1000),
        };
        localStorage.setItem(namespace, JSON.stringify(storage));
    };
    const getStorage = (key, defaultVal) => {
        const storage = getItems();
        // if the item doesn't exist, return null
        if (!storage[key]) {
            return defaultVal || null;
        }
        const item = storage[key];
        // compare the expiry time of the item with the current time
        if ((item === null || item === void 0 ? void 0 : item.expiry) && Date.now() > (item === null || item === void 0 ? void 0 : item.expiry)) {
            // If the item is expired, delete the item from storage
            // and return null
            delete storage[key];
            return defaultVal || null;
        }
        return JSON.parse(item.value);
    };
    return {
        setStorage,
        getStorage
    };
};
exports.storage = storage;
